export enum ContactType {
  Directory,
  Outlook,
}
